import {
  TKIconLeftTopBorder,
  TKIconLinkedIn,
  TKIconRightBottomBorder,
} from "assets/images/svgs";

const FoundersCard = ({
  imageUrl,
  name,
  position,
  openModal,
  openModal2,
  differ,
  link,
}) => {
  return (
    <div className="flex flex-col items-center">
      <div>
        <div
          onClick={differ ? openModal : openModal2}
          className="relative cursor-pointer"
        >
          <div>
            <img
              className={`w-full h-full object-cover`}
              src={imageUrl}
              alt={name}
            />
          </div>
          <div className="absolute -top-4 -left-5">
            <TKIconLeftTopBorder />
          </div>
          <div className="absolute -bottom-4 -right-5">
            <TKIconRightBottomBorder />
          </div>
          <div className="absolute inset-0 bg-black opacity-0 hover:opacity-50 transition-opacity duration-300 text-white flex justify-center items-center">
            <p className="px-3 py-2 text-[20px]">About</p>
          </div>
        </div>
      </div>
      <p className="mt-6 leading-[26px] text-[30px] font-semibold">{name}</p>
      <p className="mt-2 leading-[26px] text-[18px] opacity-70">{position}</p>
      <a href={link} rel="noreferrer" target="_blank">
        <TKIconLinkedIn />
      </a>
    </div>
  );
};

export default FoundersCard;
